export const LANDING_CAMERA = {
  position: [0, -0.5, 18],
  fov: 35,
  near: 0.1,
  far: 100,
};
